import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { isNil } from 'lodash';
import { SidebarService } from '../../../shared/services/sidebar.service';
import { StreetLightPlannerSidebarScenarioComponent } from '@app/energy-map/components/street-light-planner-sidebar-scenario/street-light-planner-sidebar-scenario.component';
import { MapPopupComponent } from '../map-popup.component';
import { AuthService } from '@app/shared/services/auth.service';
import { MapService } from '@app/energy-map/services/map.service';
import { LampsSelectedService } from '@app/energy-map/services/lamps-selected.service';
import { mergeMap, takeUntil, tap } from 'rxjs/operators';
import { EnergyMapService } from '@app/energy-map/services/energy-map-service';
import { Subject, of } from 'rxjs';

@Component({
  selector: 'app-lamp-popup',
  templateUrl: './lamp-popup.component.html',
  styleUrls: ['./lamp-popup.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class LampPopupComponent extends MapPopupComponent implements OnInit, OnDestroy {
  protected unsubscribe$: Subject<void> = new Subject<void>();
  public isKam = true;
  public isManualSelect = false;
  public isClicked = false;
  public mastHeight = 0;
  luminaires: any[] = [];
  labelPosition = 'after';
  isMultipleLuminaire = false;
  selectedLamp: any;
  isLampDetailShown: boolean = false;

  constructor(
    public authService: AuthService,
    public mapService: MapService,
    public sidebarService: SidebarService,
    public lampsSelectedService: LampsSelectedService,
    private energyMapService: EnergyMapService
  ) {
    super();
  }

  public ngOnInit(): void {
    this.mastHeight = this.parseMastHeight(this.data.mastHeight);
    this.isKam = this.authService.isKAM;
    this.isLampDetailShown = false;
    this.selectedLamp = null;

    this.mapService.manualSelectModeChange.pipe(takeUntil(this.unsubscribe$)).subscribe((value: boolean) => {
      this.isManualSelect = value;
    });

    this.mapService.isClickedModeChange.pipe(takeUntil(this.unsubscribe$)).subscribe((value: boolean) => {
      this.isClicked = value;
      this.updateCheckbox.emit();
    });

    this.isMultipleLuminaire = this.data.hasMultipleLamps;

    if (this.isMultipleLuminaire) {
      this.data.lamps.forEach((l: any) => {
        l.isExcluded = this.lampsSelectedService.isExcludedFromPlanning(l);
      });
    }

    this.lampsSelectedService.lampRemoved
      .pipe(
        mergeMap(
          (i) =>
            of(i).pipe(
              tap((lamp: any) => {
                this.data.lamps.forEach((l: any) => {
                  if (l.assetId === lamp.assetId) {
                    l.selected = false;
                    this.updatePopup.emit();
                  }
                });
              })
            ),
          2
        ),
        takeUntil(this.unsubscribe$)
      )
      .subscribe();

    this.lampsSelectedService.lampAdded.pipe(takeUntil(this.unsubscribe$)).subscribe((lamp: any) => {
      this.data.lamps.forEach((l: any) => {
        if (l.assetId === lamp.assetId) {
          l.selected = true;
          this.updateCheckbox.emit();
        }
      });
    });

    this.energyMapService.lampPopupClose.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
      this.selectedLamp = null;
      this.isLampDetailShown = false;
    });
  }

  public ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  public showSidebar(): void {
    this.sidebarService.showComponent(StreetLightPlannerSidebarScenarioComponent);
    this.closePopup();
    this.isLampDetailShown = false;
    this.selectedLamp = null;
  }

  private parseMastHeight(mastHeight: string): number {
    if (isNil(mastHeight)) {
      return 0;
    }
    return +mastHeight.replace(',', '.');
  }

  public checkChanged(lamp: any): void {
    lamp.selected = !lamp.selected;

    if (!lamp.selected) {
      this.lampsSelectedService.remove(lamp);
    } else {
      this.lampsSelectedService.addLamp(lamp);
    }

    this.updateCheckbox.emit();
  }

  public showDetails(lamp: any): void {
    if (!(this.isManualSelect && this.isClicked)) {
      this.isLampDetailShown = true;
      this.selectedLamp = lamp;
      this.mastHeight = lamp.mastHeight;
      this.openLampDetail.emit();
    }
  }

  public closeDetails(): void {
    this.isLampDetailShown = false;
    this.selectedLamp = null;
    this.closeLampDetail.emit();
  }

  public closePopup(): void {
    this.updateCheckbox.emit();
    this.isLampDetailShown = false;
    this.selectedLamp = null;
    this.closeLampDetail.emit();
    this.closeEvent.emit();
  }

  public trackByFn(_: number, item: any): any {
    return item.assetId;
  }
}
